/* AOF scroll-reveal — IntersectionObserver fade-in */
(function () {
  /* Content visibility must never be gated on the animation: with no
     IntersectionObserver, reveal everything immediately instead of
     leaving .aof-reveal elements at opacity 0 forever. */
  if (!('IntersectionObserver' in window)) {
    const revealAll = () => {
      document.querySelectorAll('.aof-reveal').forEach((el) => {
        el.classList.add('is-visible');
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', revealAll);
    } else {
      revealAll();
    }
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
  );

  function observe() {
    document.querySelectorAll('.aof-reveal:not(.is-visible)').forEach((el) => {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  /* Re-observe after Shopify AJAX section renders */
  document.addEventListener('shopify:section:load', observe);
})();
